module.exports = __webpack_public_path__ + "static/media/TT-Norms-Pro-Thin.a3484902.ttf";